import type { PageConfig } from '../types';

export const revivalResultsPageConfig: PageConfig = {
  id: 'revival-results',
  tabLabel: 'Revival results',
  sections: [
    {
      id: 'hero',
      layout: 'grid-1',
      items: [{ kind: 'metric', id: 'sales_influenced', span: 'full' }],
    },
    {
      id: 'revival-stats',
      layout: 'grid-3',
      items: [
        { kind: 'metric', id: 'top_n_nameplate_share' },
        { kind: 'metric', id: 'revived_sales_new_units' },
        { kind: 'metric', id: 'revived_sales_used_cpo_units' },
      ],
    },
    {
      id: 'gross-breakdown',
      overline: 'WHERE THE GROSS SHOWED UP',
      titleFromMetric: true,
      layout: 'grid-1',
      items: [{ kind: 'metric', id: 'revived_sales_by_vehicle_model', span: 'full' }],
    },
    {
      id: 'revival-sources',
      overline: 'FROM NO SIGNAL TO SIGNAL',
      title: 'Where did the revivals come from',
      layout: 'grid-3',
      items: [
        {
          kind: 'metric',
          id: 'revived_sales_from_leads_older_than_90d_share',
          presentation: { detailLevel: 'full' },
        },
        {
          kind: 'metric',
          id: 'revived_sales_marked_dead_in_crm_share',
          presentation: { detailLevel: 'full' },
        },
        {
          kind: 'metric',
          id: 'revived_sales_no_prior_relationship_share',
          presentation: { detailLevel: 'full' },
        },
      ],
    },
    {
      id: 'customer-journey',
      overline: "ONE CUSTOMER'S JOURNEY",
      titleFromMetric: true,
      layout: 'grid-1',
      items: [{ kind: 'insight', id: 'customer_journey_timeline', span: 'full' }],
    },
  ],
};
